import styled from 'styled-components/macro';
export const ElvisImageLink = styled.a `
  display: block;
`;
